// Labels and wording for company documents (app/services/documents.py has the same lists)

export const DOCUMENT_KIND_LABELS = {
  nda: 'NDA',
  mnda: 'Mutual NDA',
  cnda: 'Confidential NDA',
  msa: 'MSA',
  sow: 'SOW',
  dpa: 'DPA',
  other: 'Other'
};

export const DOCUMENT_STATUS_LABELS = {
  sent: 'Sent',
  received: 'Received',
  signed_by_partner: 'Signed by partner',
  signed_by_tileward: 'Signed by Tileward',
  fully_signed: 'Fully signed',
  withdrawn: 'Withdrawn'
};

// The dates a form can set, and the one each status stands for
export const DOCUMENT_DATE_FIELDS = [
  ['sent_at', 'Sent'],
  ['received_at', 'Received'],
  ['partner_signed_at', 'Signed by partner'],
  ['tileward_signed_at', 'Signed by Tileward'],
  ['fully_signed_at', 'Fully signed'],
  ['effective_at', 'Effective'],
  ['expires_at', 'Expires']
];

const DAY_MS = 24 * 60 * 60 * 1000;

// Whole days from today to a 'YYYY-MM-DD' date (negative when it is past), in local time
export const daysFromToday = (isoDate, now = new Date()) => {
  if (!isoDate) return null;
  const [year, month, day] = isoDate.split('-').map(Number);
  if (!year || !month || !day) return null;
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((Date.UTC(year, month - 1, day) - today) / DAY_MS);
};

const daysPhrase = (days) => {
  const count = Math.abs(days);
  if (count === 0) return 'today';
  if (count === 1) return days < 0 ? 'yesterday' : 'tomorrow';
  return days < 0 ? `${count} days ago` : `in ${count} days`;
};

// The status pill: "Sent 20 days ago" while a reply is awaited, otherwise just the status
export const statusPillText = (document, now = new Date()) => {
  const label = DOCUMENT_STATUS_LABELS[document.status] || document.status;
  const waiting = { sent: document.sent_at, received: document.received_at }[document.status];
  const days = waiting ? daysFromToday(waiting, now) : null;
  return days !== null && days <= 0 ? `${label} ${daysPhrase(days)}` : label;
};

// "Expired 3 days ago" or "Expires in 30 days" (only within a quarter), else null; the server says
// whether it has expired, and the date never changes the status
export const expiryText = (document, now = new Date()) => {
  if (!document.expires_at || document.status === 'withdrawn') return null;
  const days = daysFromToday(document.expires_at, now);
  if (days === null) return null;
  if (document.expired || days < 0) return `Expired ${daysPhrase(days)}`;
  return days <= 90 ? `Expires ${daysPhrase(days)}` : null;
};

// Only an https link on Google Drive is worth showing as a link
export const isDriveLink = (url) => {
  try {
    const { protocol, hostname } = new URL(url);
    return protocol === 'https:' && ['drive.google.com', 'docs.google.com'].includes(hostname);
  } catch (error) {
    return false;
  }
};
